var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M18 14a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm2.707-10.707a1 1 0 0 1 0 1.414l-16 16a1 1 0 0 1-1.414-1.414l16-16a1 1 0 0 1 1.414 0zM6 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }